import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0M9.323 6.644q-1.313.546-5.25 2.261-.638.255-.669.497c-.034.274.309.382.776.529l.197.062c.46.15 1.078.325 1.399.332q.437.01.976-.361 3.677-2.482 3.796-2.51c.056-.012.134-.028.187.019s.047.135.042.159c-.034.145-1.38 1.397-2.078 2.044-.217.202-.37.345-.402.378q-.108.11-.212.21c-.427.411-.747.72.018 1.224.367.242.661.442.955.642.32.218.64.436 1.053.707q.158.104.304.21c.373.266.708.505 1.122.467.24-.022.489-.248.615-.923.298-1.594.884-5.047 1.02-6.47a1.6 1.6 0 0 0-.015-.355.38.38 0 0 0-.129-.243.6.6 0 0 0-.348-.105c-.339.006-.858.187-3.357 1.226",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }